import { IonContent, IonInput, IonPage, IonText,IonSpinner } from "@ionic/react"
import { useEffect, useState, useMemo } from "react"
import { Modal } from "react-bootstrap"
import moment from "moment";
import { useHistory } from "react-router"
import DataTable from "react-data-table-component"
import service from "../../../Service/service"
import Head from "../../Header"
import Sidebar from "../../Sidebar"
import swal from 'sweetalert';
const LeaveApproval: React.FC = () => {
    const history = useHistory();
    const [token] = useState(localStorage.getItem("SignupEmpId"));
    const [id, setId] = useState("");
    const [data, setData] = useState([]);
    const [empCode, setEmpCode] = useState("");
    const [empid,setEmpId]=useState("")
    const [filterText, setFilterText] = useState("");
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
    const [modalopen, setModalopen] = useState(false);
    const [statusList, setStatusList] = useState([]);
    const [leave, setLeave] = useState("");
    const [leaveType, setLeaveType] = useState("");
    const [status, setStatus] = useState("");
    const [status1, setStatus1] = useState("");
    const [approvedBy, setApprovedBy] = useState("");
    const [fromDate, setFromDate] = useState("");
    const [toDate, setTodate] = useState("");
    const [leaveReason, setLeaveReason] = useState("");
    const [reportingPerson, setReportingPerson] = useState("");
    const [remarks, setRemarks] = useState("");
    const [noOfDays, setNoOfDays] = useState("");
    const [empName, setEmpName] = useState("");
    const [loading,setloading]=useState(false)

    useEffect(() => {
        if (token === null) {
            history.push("/login");
        } else {
        }
    }, [token, history]);
   
 

    useEffect(() => {
        Leaveapproval();
    }, []);
  
// -----------------------Modal View -----------------------

    const openmodal = (itm: any,id:any) => {
        setModalopen(true);
        GetStatusList();
        setId(id);
        service.GetLeaveDetailsById(itm.id)
            .then((response) => {
                console.log(response, "lmlml")

                if (response.data.Status === "200") {
                    setLeave(response.data.Data.leaveType.id);
                    setLeaveType(response.data.Data.leaveType.leaveType);
                    setFromDate(response.data.Data.fromDate);
                    setEmpName(response.data.Data.empName)
                    setEmpId(response.data.Data.empCode)
                    setTodate(response.data.Data.toDate);
                    setLeaveReason(response.data.Data.reason);
                    setReportingPerson(response.data.Data.reportingPerson[0])
                    setNoOfDays(response.data.Data.noOfDays);
                    setEmpCode(response.data.Data.empCode);
                }
            })
            .catch((error) => {
                console.log(error)
            })
    }

// -----------------------Leave Approval-----------------------

const Leaveapproval = () => {
    setloading(true);
    service.Pendingleave(token)
        .then((response) => {
            console.log(response);
            if (response.status === 200) {
                setData(response.data);
            } else {
                setData([]);
            }
        })
        .catch((error) => {
            console.log(error);
        })
        .finally(() => {
            // This code will execute whether the promise is resolved or rejected
            setTimeout(() => {
                setloading(false); // Hide loading after a delay (e.g., 1000 milliseconds)
            }, 500); // Adjust the timeout duration as needed
        });
};


    const back = () => {
        history.goBack();
    }


   //-----------------Api for Status---------------------//
   const GetStatusList = () => {
    service.GetLeaveApprovalStatusDropDown()
        .then((response) => {
            console.log(response);
            if (response.data.Status === "200") {
                for (let i = 0; i < response.data.Data.length; i++) {
                    if (response.data.Data[i].status === "Approved") {
                        setStatus(response.data.Data[i].id)
                    }
                    else if (response.data.Data[i].status === "Rejected") {
                        setStatus1(response.data.Data[i].id)
                    }
                }
                setStatusList(response.data.Data);
            }
            else {
                setStatusList([]);
            }
        })
}
//----------------------Approve Api-----------------//

const Approve = () => {

    console.log(status, "lm")
    console.log(leave, "km")
    service.LeaveApproveByManager(id, status, leave, fromDate, toDate, leaveReason, reportingPerson, noOfDays, empCode, remarks)
        .then((response) => {
            if (response.status === 200) {
                swal("", "Updated Successfully", "success")
                window.location.reload()
            }
            else {
                swal("", "Not Updated", "error")
            }
        })
        .catch((error) => {
            console.log(error);
        });
}
//------------------Reject Api-----------------//

const Reject = () => {
    if (remarks === "") {
        swal("", "Enter the Remarks", "info")
    }
    else {
        console.log(status1, "lm")
        service.LeaveApproveByManager(id, status1, leave, fromDate, toDate, leaveReason, reportingPerson, noOfDays, empCode, remarks)
            .then((response) => {
                if (response.status === 200) {
                    swal("", "Updated Successfully", "success")
                    window.location.reload()
                }
                else {
                    swal("", "Not Updated", "error")
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }

}
    const closemodal = () => {
        setModalopen(false);
        setLeaveType("");
        setStatus("");
        setFromDate("");
        setTodate("");
        setLeaveReason("");
        setReportingPerson("");
        setNoOfDays("");
    }

    data.forEach((item: any, index: any) => { item.serial = index + 1; });
    
    const columns: any = [
        {
            name: "S.No",
            selector: (itm: any, i: any) => i + 1,
            sortable: true,
            width: "83px",
        },
        {
            name: (<div>Employee<br/>Id</div>),
            selector: (itm: any) => itm.empCode,
            width: "120px",
            sortable: true,
        },
        {
            name: (<div>Employee<br/>Name</div>),
            selector: (itm: any) => itm.empName,
            sortable: true,
            sort: "name",
            width: "200px",
            // cell: (itm: any) => (
            //     <>
            //         <div className="wrapper_cls">{itm.empName}{" ("}{itm.empCode}{")"}</div>
            //     </>
            // )
        },
        {
            name: "Reporting Manager",
            selector: (itm: any) => itm.reportingPerson,
            width: "230px",
            sortable: true,
        },
        {
            name: "Leave Type ",
            selector: (itm: any) => itm.leaveType.leaveType,
            width: "130px",
            sortable: true,

        },
        {
            name: (<div>Days/<br/>Hours</div>),
            selector: (itm: any) => itm.noOfDays,
            sortable: true,
            width: "100px",
        },
        // {
        //     name: "Request Date",
        //     sortable: true,
        //     selector: (itm: any) => itm.requestedDate,
        //     width: "150px"

        // },
        {
            name: (<div>Request<br/>Date</div>),
            sortable: true,
            selector: (itm: any) => {
              
                const dateParts = itm.requestedDate.split("-");
                if (dateParts.length === 3) {
                   
                    return `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`;
                }
            
                return itm.requestedDate;
            },
            width: "130px"
        },
        {
            name: (<div>Request<br/>Status</div>),
            sortable: true,
            width: "120px",
            cell: (itm: any) => (
                <>
                    <div className={itm.leaveStatus.status === "Approved" ? 'color_approve' : itm.leaveStatus.status === "Rejected" ? "color_deny" : "color_progress"}>{itm.leaveStatus.status}</div>
                </>
            )
        },
        {
            name: "Action",
            sortable: false,
            cell: (itm: any) => (
                <>
                    <div style={{ textDecoration: 'underline', textDecorationColor: "coral" }}>
                        <IonText onClick={() => openmodal(itm,itm.id)} style={{ color: "coral", cursor: 'pointer' }}>View</IonText>
                    </div>
                </>
            )
        }
    ]

    const datatable = data.filter(
        (item: any) =>
            JSON.stringify(item)
                .toLowerCase()
                .indexOf(filterText.toLowerCase()) !== -1
    );

    const customStyles = {
        headRow: {
            style: {
            },
        },
        headCells: {
            style: {
                fontWeight: "bold",
                fontSize: "15px"
            },
        },
        cells: {
            style: {
                fontSize: "16px"
            }
        }
    };

    const paginationComponentOptions = {
        selectAllRowsItem: true,
        selectAllRowsItemText: "ALL"
    };
    const subHeaderComponent = useMemo(() => {
        const handleClear = () => {
            if (filterText) {
                setResetPaginationToggle(!resetPaginationToggle);
                setFilterText("");
            }

        };

        return (
            <div style={{ display: "flex" }}>
                <div style={{ display: "flex" }}>
                    <div className="form-group form-focus row">
                        <IonInput type="text" className="form-control floating" onIonChange={(e: any) => setFilterText(e.target.value)}
                            value={filterText} placeholder="Search" />
                        <label className="focus-label">Search</label>
                    </div>
                    <button type="button" style={{ backgroundColor: "orange", width: "45px", marginTop: "4px", height: "40px", position: 'absolute' }} onClick={handleClear}>X</button>
                </div>
            </div>
        )

    }, [filterText, resetPaginationToggle]);


    return (
        <IonPage>
            <Head />
            <Sidebar />
            <IonContent>
                <div className="page-wrapper">
                    <div className="page-header">
                        <div className="content container-fluid">
                        <div className="row">
                            <div className="col-sm-12">
                                <h3 className="page-title"> <i className="fa fa-arrow-left" onClick={back} style={{ color: "black", cursor: "pointer", marginRight: "2px" }} /> Dashboard </h3>
                                <ul className="breadcrumb">
                                    <li className="breadcrumb-item active">Leave Approval Pending</li>
                                </ul>
                            </div>
                        </div>
                        {loading && (
                            <div
                                style={{
                                    position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'white', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999
                                }}
                            >
                                <div >
                                    <IonSpinner style={{
                                        width: "40px",
                                        height: "40px",
                                        color: "#ff8a53"
                                    }} name="lines" />
                                </div>
                            </div>
                        )}
                            <div className="table-responsive" style={{ marginTop: "2%" }}>
                                <DataTable
                                    columns={columns}
                                    data={datatable}
                                    pagination
                                    paginationPerPage={10}
                                    paginationComponentOptions={paginationComponentOptions}
                                    paginationRowsPerPageOptions={[10, 20, 30]}
                                    subHeader
                                    subHeaderComponent={subHeaderComponent}
                                    customStyles={customStyles}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <Modal
                    dialogClassName="my-modal modal-dialog-centered"
                    // id="logouts-modal"
                    show={modalopen}
                >
                    <div className="modal-header">
                        <h5 className="modal-title">View Leave</h5>
                        <button type="button" className="close" data-bs-dismiss="modal" aria-label="Close" onClick={() => closemodal()}>
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <div className="col-md-12">
                            <div className="row">
                                <div className="col-lg-6">
                                    <div className="form-group">
                                        <label style={{ fontWeight: "bold" }}> Employee Name </label>
                                        <div>
                                            <IonInput value={`${empName} (${empid})`} readonly className="form-control datetimepicker" style={{ backgroundColor: "#DCDCDC" }} />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="form-group">
                                        <label style={{ fontWeight: "bold" }}> Leave Type </label>
                                        <div>
                                            <IonInput value={leaveType} readonly className="form-control datetimepicker" style={{ backgroundColor: "#DCDCDC" }} />
                                        </div>
                                    </div>
                                </div>
                                {/* <div className="form-group">
                                                <label style={{ fontWeight: "bold" }}> Leave Disposition <span className="text-danger">*</span></label>
                                               <div>
                                              <select value={status} className="select" onChange={(e: any) => hanldeStatus(e)}>
                                              <option selected disabled value="">Approve/Reject</option>
                                                {statusList.map((state: any) => (
                                                <option key={state.id} value={state.id}>
                                                     {state.status}
                                                 </option>
                                                 ))}
                                                 </select>
                                                        </div>
                                                 </div> */}

                            </div>
                            <div className="row">
                                <div className="col-lg-6">
                                    <div className="form-group">
                                        <label style={{ fontWeight: "bold" }}> From Date </label>
                                        <div>
                                            <IonInput value={moment(fromDate).format("DD-MM-YYYY")} readonly className="form-control datetimepicker" style={{ backgroundColor: "#DCDCDC" }} />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="form-group">
                                        <label style={{ fontWeight: "bold" }}> To Date </label>
                                        <div>
                                            <IonInput value={moment(toDate).format("DD-MM-YYYY")} readonly className="form-control datetimepicker" style={{ backgroundColor: "#DCDCDC" }} />
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div className="row">
                                <div className="col-lg-6">
                                    <div className="form-group">
                                        <label style={{ fontWeight: "bold" }}> No Of Days </label>
                                        <div>
                                            <IonInput value={noOfDays} readonly className="form-control datetimepicker" style={{ backgroundColor: "#DCDCDC" }} />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="form-group">
                                        <label style={{ fontWeight: "bold" }}> Reporting Persons </label>
                                        <div>
                                            <IonInput value={reportingPerson} readonly className="form-control datetimepicker" style={{ backgroundColor: "#DCDCDC" }} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-6">
                                    <div className="form-group">
                                        <label style={{ fontWeight: "bold" }}> Reason for Leave </label>
                                        <div>
                                            <textarea
                                                value={leaveReason}
                                                readOnly
                                                // className="form-control"
                                                style={{ backgroundColor: "#DCDCDC", resize: "vertical", width: "100%", border: "none", borderRadius: '5px' }}
                                                rows={3}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="form-group">
                                        <label style={{ fontWeight: "bold" }}> Remarks </label>
                                        <div>
                                            <IonInput value={remarks} className="form-control datetimepicker" onIonChange={(e: any) => setRemarks(e.detail.value)} />
                                        </div>
                                    </div>
                                </div>

                                {/* ------------------ */}
                            </div>
                        </div>
                        {/* <a style={{ color: "red" }}>Alert ?</a><br></br> */}
                        {/* <div style={{ width: "100%", display: "flex", justifyContent: 'center', marginTop: '2%' }}>
                            <a style={{ textAlign: 'center', display: 'block' }}>
                                <a style={{ color: "red" }}>Alert !</a><br></br><a style={{ color: 'red' }}> While Approving Leave</a>  <br />
                                <span style={{ display: 'inline-block', textAlign: 'center', color: "red" }}>
                                    Check the correctness of leave dates (From and To) and also the Leave Days.
                                    <br />
                                    This version of IC Panel does not have any validation on these fields.
                                </span>
                            </a>

                        </div> */}
                        <div className="row">
                            <div className="col-md-6">
                                <div className="submit-section">

                                    <button type="button" className="btn-primary submit-btn" onClick={() => Approve()}>Approve</button>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="submit-section">
                                    <button type="button" className="btn-primary submit-btn" onClick={() => Reject()}>Reject</button>
                                </div>
                            </div>
                        </div>

                    </div>
                </Modal>
            </IonContent>
        </IonPage>
    )

}

export default  LeaveApproval;